"use strict";

exports.__esModule = true;
exports.default = each;
var _optimizeCb = _interopRequireDefault(require("./_optimizeCb.js"));
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _keys2 = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = (0, _optimizeCb.default)(iteratee, context);
  var i, length;
  if ((0, _isArrayLike.default)(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = (0, _keys2.default)(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}